import api from '@/components/mixins/baseApi';

export default {
  mixins: [api],
  methods: {
    getExhibitorList(page = null, search = null, params = null) {
      this.$store.commit('setProgressVal', 1);
      const urlPage = page ? `/${page}` : '';
      // строку запроса собирает axios: подставленный в адрес поиск ломался
      // на «&», «#», «+» — они в адресе значат разделители, а не текст
      const query = { ...(params || {}) };
      if (search) query.search = search;
      return this.baseAxios({
        method: 'get',
        url: `${this.$store.getters.apiBasePath}/exhibitor/page${urlPage}`,
        params: query,
        onDownloadProgress: (progressEvent) => {
          this.$store.commit('setProgressVal', Math.round(progressEvent.progress * 100));
        },
      })
        .then((data) => {
          this.$store.commit('setProgressVal', 100);
          return data;
        })
        .catch((error) => {
          this.$store.commit('setProgressVal', 100);
          return error;
        });
    },
    getExhibitorPersone(id) {
      this.$store.commit('setProgressVal', 1);
      return this.baseAxios({
        method: 'get',
        url: `${this.$store.getters.apiBasePath}/exhibitor/${id}`,
        onDownloadProgress: (progressEvent) => {
          this.$store.commit('setProgressVal', Math.round(progressEvent.progress * 100));
        },
      })
        .then((data) => data.results || {})
        .catch(() => {
          this.$store.commit('setProgressVal', 100);
          return false;
        });
    },
    getExhibitorByStand(_standID) {
      return this.baseAxios({
        method: 'get',
        url: `${this.$store.getters.apiBasePath}/exhibitor/stand/${_standID}`,
      })
        .then((data) => data.results || null)
        .catch((error) => {
          console.error(error);
          return null;
        });
    },
  },
};
